import { BASE_URL } from '../constants'
import useFetch from '../hooks/useFetch'

export const usePostsByIncidentId = (incidentId) =>
  useFetch(
    `${BASE_URL}api/sitrep/posts/byIncidentId/${incidentId}`,
    {},
    [incidentId],
    incidentId !== null
  )
export const usePost = (postId) =>
  useFetch(`${BASE_URL}api/sitrep/posts/byId/${postId}`, {}, [postId])
export const useIncidents = () => useFetch(`${BASE_URL}api/sitrep/incidents`)
